import { render, staticRenderFns } from "./Apertura.vue?vue&type=template&id=682a2cf7&"
import script from "./Apertura.vue?vue&type=script&lang=js&"
export * from "./Apertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports